import { filterMatchMode } from '../../constants/enum';
import { MasterCsvRow, MasterFilterCondition } from '../../types/masterReconciliation';

/**
 * 候補のマスタ列の値が、その列の絞り込み条件に合わないかを判定する（#3408）。
 *
 * 再照合モーダルでは、絞り込み条件に合わないのにマスタ名称は類似として候補に出る
 * （照合履歴経由など）ことがあるため、合わない列の値を赤字＋注意アイコンにして気付けるようにする。
 *
 * 判定は functions 側の matchesFilterConditions と同一の意味論にそろえる:
 *   - exact   : 完全一致（値が無い候補は不一致）
 *   - keyword : 部分一致（大文字小文字を区別しない。ILIKE と同じ）
 *
 * 合わない場合はその条件を返す（注意アイコンのツールチップで条件を示すため）。
 * 列に絞り込み条件が無い・条件に合う場合は undefined を返す。
 */
export const findFilterMismatch = (
  rawData: MasterCsvRow | undefined,
  csvColumn: string,
  conditions: MasterFilterCondition[] | undefined,
): MasterFilterCondition | undefined => {
  const condition = conditions?.find(c => c.csvColumn === csvColumn);
  if (!condition) return undefined;

  const target = rawData?.[csvColumn] ?? '';
  const matched =
    condition.filterMatchMode === filterMatchMode.keyword
      ? target.toLowerCase().includes(condition.value.toLowerCase())
      : target === condition.value;
  return matched ? undefined : condition;
};
